import React, { useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { PolygonData } from "types/models/master/MasterApp";
import OrderActions from "./OrderActions";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Label } from "recharts";

const COLUMN_WIDTH = 200;

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 16,
  width: COLUMN_WIDTH,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
}));

interface TableItemProps {
  data: PolygonData;
}

const TableItem: React.FC<TableItemProps> = ({ data }) => {
  const [openDialog, setOpenDialog] = useState(false);

  const getStatusColor = (isActive: boolean) => {
    return isActive ? "#43C888" : "#F84E4E";
  };

  const handleInfoClick = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <TableRow key={data.id} className="item-hover">
        <StyledTableCell align="left">{data.stateName}</StyledTableCell>

        <StyledTableCell align="left">{data.city_name}</StyledTableCell>

        <StyledTableCell align="left">{data.area_name}</StyledTableCell>

        <StyledTableCell align="left">
          <Box display="flex" alignItems="center">
            <span
              onClick={handleInfoClick}
              style={{
                cursor: 'pointer',
                color: '#3a3a3a',
                 backgroundColor: 'rgba(241, 90, 41, 0.6)', 
                padding: '4px 8px',
                borderRadius: '4px'
              }}
            >
              View
            </span>
          </Box>
        </StyledTableCell>

        <StyledTableCell align="left">
          <Box
            sx={{
              color: getStatusColor(data.isActive),
              backgroundColor: getStatusColor(data.isActive) + "44",
              padding: "3px 5px",
              borderRadius: 1,
              fontSize: 14,
              display: "inline-block",
              minWidth: 80,
              textAlign: "center",
            }}
          >
            {data.isActive ? "Mapped" : "Pending"}
          </Box>
        </StyledTableCell>

        <StyledTableCell align="left">
          {data.status ? data.status : ""}
        </StyledTableCell>

        <StyledTableCell align="left">
          <OrderActions data={data} />
        </StyledTableCell>
      </TableRow>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="location-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          id="location-dialog-title"
          sx={{
            fontSize: '20px',
            fontWeight: 'bold',
          }}
        >
          Network Partners
        </DialogTitle>

        <DialogContent dividers>

          {data.network_partners
            ? data.network_partners.split(',').map((np, index) => (
              <Typography key={index} variant="body1">
                Network Partner {index + 1}: {np.trim()}
              </Typography>
            ))
            : <Typography variant="body1">N/A</Typography>
          }
        </DialogContent>


        <DialogActions>
          <Button onClick={handleCloseDialog} variant="contained" size="small">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TableItem;
